import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function markAsRead(uId, tableId, triiboId) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .post(
            `${cfac22('API_HOST_V2')}/notification/markAsRead`,
            {
              tableId,
              triiboId,
            },
            { headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href } }
          )
          .then((result) => {
            // console.log("RESULT_MARK_AS_READ: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERROR_MARK_AS_READ: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKEN:", error);
        reject(error);
      });
  });
}
